import React, { useEffect, useState } from "react";
import { t } from "i18next";

import InputColorPicker from "../../shared/inputColorPicker/InputColorPicker";
import PageTitle from "../../shared/pageTitle/PageTitle";

import { UploadImage } from "../../shared-v2/UploadImage";
import { Subtitle } from "../../shared-v2/Subtitle";
import { Label } from "../../shared-v2/Label";

import { breakpointSize } from "../../../theme/mediaQuerie";
import { RowGrid, InputGroup, Row, Column } from './style';
import { Select } from "../../shared/InputSelect/style";
import { Text } from "../../dashboard/BannerLoad/style";
import tutoriaGift from "../../../assets/tutorial.gif";
import UploadBanner from "../../shared/UploadBanner";
import { dashboardApi } from "../../../api/DashboardApi";
import colors from "../../../theme/colors";

interface IProps {
  dataConfig: any;
  setDataConfig: any;
  groups: any;
  channel: string;
}

const isMobile = window.innerWidth <= breakpointSize.Sm;

export const Panel = ({ dataConfig, setDataConfig, groups, channel }: IProps) => {
  const [file, setFile] = useState<any | null>(null);
  const [banners, setBanners] = useState<any>(dataConfig.images.banners);
  const [showTutorial, setShowTutorial] = useState(false);
  const [banner, setBanner] = useState(dataConfig.banner);

  useEffect(() => {
    setDataConfig((prev: any) => ({ ...prev, images: {...prev.images, banners: banners}, banner: banners.length > 0 ? banners[0] : {}}));
  }, [banners]);

  useEffect(() => {
   if(dataConfig.banner){
     setBanner({
      ...dataConfig.banner, 
      desktop_name: dataConfig.banner.desktop_name || dataConfig.banner.name, 
      name: dataConfig.banner.name, 
      desktop_url: dataConfig.banner.desktop_url || dataConfig.banner.url, 
    });
   }
  }, [dataConfig])

  function onChangeBodyData(key: string, secondaryKey: string, thirdKey: string, value: string) {
    setDataConfig({ ...dataConfig, [key]: { ...dataConfig[key], [secondaryKey]: { ...dataConfig[key][secondaryKey], [thirdKey]: value } } });
  }

  function onChangeHeaderData(key: string, secondaryKey: string, value: string) {
    setDataConfig({ ...dataConfig, [key]: { ...dataConfig[key], [secondaryKey]: value } });
  }

  const onChangeLogoData = (value: any) => {
    setDataConfig((prev: any) => ({ ...prev, header: { ...prev.header, logo: value.file } }));
  }

   async function onDeleteBanner(index: number, type: string) {
    await dashboardApi.deleteBanner(
      'first_desktop',
      channel
    );

    setBanners((prev: any) => [{
      ...prev[0],
        [`desktop_file`]: "",
        [`desktop_url`]: "",
    }]);
  }

  return (
    <>
      {!isMobile && <PageTitle style={{ margin: 0 }}>{t("dashboard.conference.header.title")}</PageTitle>}
      <RowGrid>
        <Column style={{gap: 0}}>
          <Subtitle>{t("Content")}</Subtitle>
            <Row>
            <Text style={{ fontWeight: "400", fontSize: "16px", color: "#A0A3BD", maxWidth: "227px" }}>{t("selectGroup")}</Text>
            <Column style={{ width: "100%", marginTop: '32px' }}>
              <Select value={dataConfig?.enabled_groups?.length > 0 && groups.find((item: any) => item.id === dataConfig.enabled_groups[0])} style={{ width: "100%", maxWidth: "240px" }} onChange={(event) => {
                setDataConfig({ ...dataConfig, enabled_groups: [event.target.value] });
              }}>
                {groups && groups.map((group: any) => (
                  <option value={group.id}>{group.name}</option>
                ))}
              </Select>
              <Text style={{ fontWeight: "400", fontSize: "8px", color: "#A0A3BD" }}>{t("select.only.one")}</Text>
            </Column>
            </Row>
        </Column>
      </RowGrid>

      <Column>
        <Row style={{ justifyContent: "space-between", flexDirection: "row", marginBottom: '32px' }}>
          <Subtitle>{t("enrollment")}</Subtitle>
          <Column style={{ position: "relative" }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" onMouseEnter={() => setShowTutorial(true)} onMouseLeave={() => setShowTutorial(false)}>
              <path d="M9.95963 14.9998C10.2513 14.9998 10.4978 14.8991 10.6992 14.6978C10.9006 14.4964 11.0013 14.2498 11.0013 13.9582C11.0013 13.6665 10.9006 13.42 10.6992 13.2186C10.4978 13.0172 10.2513 12.9165 9.95963 12.9165C9.66797 12.9165 9.42144 13.0172 9.22005 13.2186C9.01866 13.42 8.91797 13.6665 8.91797 13.9582C8.91797 14.2498 9.01866 14.4964 9.22005 14.6978C9.42144 14.8991 9.66797 14.9998 9.95963 14.9998ZM9.20963 11.7915H10.7513C10.7513 11.3332 10.8034 10.9721 10.9076 10.7082C11.0117 10.4443 11.3069 10.0832 11.793 9.62484C12.1541 9.26373 12.4388 8.91998 12.6471 8.59359C12.8555 8.2672 12.9596 7.87484 12.9596 7.4165C12.9596 6.63873 12.6749 6.0415 12.1055 5.62484C11.536 5.20817 10.8624 4.99984 10.0846 4.99984C9.29297 4.99984 8.65061 5.20817 8.15755 5.62484C7.6645 6.0415 7.32075 6.5415 7.1263 7.12484L8.5013 7.6665C8.57075 7.4165 8.727 7.14567 8.97005 6.854C9.21311 6.56234 9.58463 6.4165 10.0846 6.4165C10.5291 6.4165 10.8624 6.53803 11.0846 6.78109C11.3069 7.02414 11.418 7.2915 11.418 7.58317C11.418 7.86095 11.3346 8.12136 11.168 8.36442C11.0013 8.60748 10.793 8.83317 10.543 9.0415C9.93186 9.58317 9.55686 9.99289 9.41797 10.2707C9.27908 10.5484 9.20963 11.0554 9.20963 11.7915ZM10.0013 18.3332C8.84852 18.3332 7.76519 18.1144 6.7513 17.6769C5.73741 17.2394 4.85547 16.6457 4.10547 15.8957C3.35547 15.1457 2.76172 14.2637 2.32422 13.2498C1.88672 12.2359 1.66797 11.1526 1.66797 9.99984C1.66797 8.84706 1.88672 7.76373 2.32422 6.74984C2.76172 5.73595 3.35547 4.854 4.10547 4.104C4.85547 3.354 5.73741 2.76025 6.7513 2.32275C7.76519 1.88525 8.84852 1.6665 10.0013 1.6665C11.1541 1.6665 12.2374 1.88525 13.2513 2.32275C14.2652 2.76025 15.1471 3.354 15.8971 4.104C16.6471 4.854 17.2409 5.73595 17.6784 6.74984C18.1159 7.76373 18.3346 8.84706 18.3346 9.99984C18.3346 11.1526 18.1159 12.2359 17.6784 13.2498C17.2409 14.2637 16.6471 15.1457 15.8971 15.8957C15.1471 16.6457 14.2652 17.2394 13.2513 17.6769C12.2374 18.1144 11.1541 18.3332 10.0013 18.3332ZM10.0013 16.6665C11.8624 16.6665 13.4388 16.0207 14.7305 14.729C16.0221 13.4373 16.668 11.8609 16.668 9.99984C16.668 8.13873 16.0221 6.56234 14.7305 5.27067C13.4388 3.979 11.8624 3.33317 10.0013 3.33317C8.14019 3.33317 6.5638 3.979 5.27214 5.27067C3.98047 6.56234 3.33464 8.13873 3.33464 9.99984C3.33464 11.8609 3.98047 13.4373 5.27214 14.729C6.5638 16.0207 8.14019 16.6665 10.0013 16.6665Z" fill="#A0A3BD" />
            </svg>
            {showTutorial && (
              <img src={tutoriaGift} style={{ position: "absolute", top: "19px", right: "2px", borderRadius: "8px", height: "150px", width: "300px", zIndex: 10 }} alt="tutorial" />
            )}
          </Column>
        </Row>

        <RowGrid>
          <Row style={{ gap: "32px" }}>
            <InputGroup>
              <Label>{t("background.color")}</Label>
              <InputColorPicker
                color={dataConfig?.body?.form?.pageBackground}
                handleChangeColor={(e) => onChangeBodyData("body", "form", "pageBackground", e.hex)}
              />
            </InputGroup>

            <InputGroup>
              <Label>{t("bannerColor")}</Label>
              <InputColorPicker
                color={dataConfig?.body?.form?.bannerBackground}
                handleChangeColor={(e) => onChangeBodyData("body", "form", "bannerBackground", e.hex)}
              />
            </InputGroup>

            <InputGroup>
              <Label>{t("tagColor")}</Label>
              <InputColorPicker
                color={dataConfig?.body?.form?.tagColor}
                handleChangeColor={(e) => onChangeBodyData("body", "form", "tagColor", e.hex)}
              />
            </InputGroup>
          </Row>
        </RowGrid>
      </Column>

      <Column>
        <Row>
          <Subtitle>{t("userArea")}</Subtitle>
        </Row>

        <RowGrid style={{ gap: "32px"}}>
          <Column style={{ gap: "16px" }}>
            <InputGroup>
              <Label>{t("header")}</Label>
              <InputColorPicker
                color={dataConfig?.header?.backgroundColor}
                handleChangeColor={(e) => onChangeHeaderData("header", "backgroundColor", e.hex)}
              />
            </InputGroup>

            <InputGroup>
              <Label>{t("titleBackground")}</Label>
              <InputColorPicker
                color={dataConfig?.body?.watch?.descriptionBackground}
                handleChangeColor={(e) => onChangeBodyData("body", "watch", "descriptionBackground", e.hex)}
              />
            </InputGroup>
          </Column>

          <UploadImage
            file={file ? file : { url: dataConfig?.images?.logo }}
            maxImageSize={1024 * 1024 * 10}
            setFile={(file) => {
              onChangeLogoData(file ?? "");
              setFile(file);
            }}
            title="Logo"
            id="header-banner"
          />
        </RowGrid>
      </Column>

      <Column>
        <Row>
          <Subtitle>{t("backgroundImage")}</Subtitle>
        </Row>
        <InputGroup style={{marginTop: "32px"}}>
          <Label>{t("backgroundImage")}</Label>
          <UploadBanner
            styleForInputLabelContainer={{backgroundColor: colors.background, padding: '32px', borderRadius: '8px'}}
            styleForUploadedContainer={{backgroundColor: colors.background, padding: '32px', borderRadius: '8px'}}
            fileImageUrl={(dataConfig.images.banners && dataConfig.images.banners[0]) ? dataConfig.images.banners[0].url : ""}
            setBanner={setBanners}
            inputId={"input-file-desktop1"}
            idForUploadButton="input-upload-desktop"
            isDesktop={true}
            type={`desktop`}
            index={0}
            banner={banner}
            onDeleteBanner={onDeleteBanner}
          />
        </InputGroup>
        </Column>
      {/* <InputModal
        onConfirm={addMenuItem}
        onCancel={() => { setShowInputModal(false); setNewMenuItemTitle(""); }}
        setShowModal={setShowInputModal}
        showModal={showInputModal}
        setValue={setNewMenuItemTitle}
        value={newMenuItemTitle}
        title={t("newButton")}
        inputRequired
        label={t("dashboard.event.dataConfig.newButtonLabel")}
      /> */}
    </>
  );
}